import React from 'react';
import styles from './BottomCarSearch.module.css';
import { RoundIcon, RoundIconVariants } from '@components/atoms/RoundIcon';
import { useTranslation } from 'react-i18next';

export const BottomCarSearch: React.FC<{
    activeIcon: 'disponivel' | 'proximo' | null;
    onIconClick: (icon: 'disponivel' | 'proximo') => void;
}> = ({ activeIcon, onIconClick }) => {
    const { t } = useTranslation();

    const translations = {
        available: t('bottom-car-search.available'),
        closer: t('bottom-car-search.closer'),
    };

    return (
        <div className={styles.containerBar}>
            <RoundIcon
                variant={RoundIconVariants.variant4}
                text={translations.available}
                icon="fa-thin fa-car-on"
                onClick={() => onIconClick('disponivel')}
                active={activeIcon === 'disponivel'}
            />
            <RoundIcon
                variant={RoundIconVariants.variant4}
                text={translations.closer}
                icon="fa-thin fa-car"
                onClick={() => onIconClick('proximo')}
                active={activeIcon === 'proximo'}
            />
        </div>
    );
};
